// src/components/Header.jsx
import { FaRegCircleUser, FaPowerOff } from 'react-icons/fa6';

function Header({ user, collapsed }) {
    const indeks = user?.indeks ?? '—';

    const roleTitle =
        user?.rola === 'student'
            ? 'Panel studenta'
            : user?.rola === 'prowadzacy'
                ? 'Panel prowadzącego'
                : user?.rola === 'admin'
                    ? 'Panel administratora'
                    : '';

    return (
        <header
            style={{
                height: 60,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 12px',
                background: '#0f172a',
                borderBottom: '1px solid #0f172a',
                position: 'fixed',
                top: 0,
                left: collapsed ? '58px' : '244px', // dopasuj do szerokości sidebaru
                right: 0,
                zIndex: 50,
                transition: 'left 200ms ease'
            }}
        >
            {/* LEWO: tytuł panelu zależny od roli */}
            <div style={{ color: '#fff', fontWeight: 400, letterSpacing: '3px', marginLeft: 20 }}>
                {roleTitle}
            </div>

            {/* PRAWO: ikona usera + indeks + wyloguj */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <FaRegCircleUser size={22} color="#ffffff" aria-hidden />
                <span style={{ color: '#ffffff', fontWeight: 600 }}>{String(indeks)}</span>
                <button
                    onClick={() => {
                        localStorage.removeItem('token');
                        window.location.reload();
                    }}
                    title="Wyloguj"
                    aria-label="Wyloguj"
                    style={{
                        display: 'grid',
                        placeItems: 'center',
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        border: '1px solid rgba(255,255,255,0.15)',
                        background: 'transparent',
                        cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.06)')}
                    onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
                >
                    <FaPowerOff size={18} color="#ef4444" />
                </button>
            </div>
        </header>
    );
}

export default Header;
